import React, { useEffect, useState } from 'react';
import { Native, env } from '@hb/hbridge';
import nativeBridge from '@/utils/nativeBridge';

import './index.less';

interface IProps {
  className?: string;
  rightContent?: React.ReactNode;
  title?: any;
  isBlack?: boolean;
  style?: any;
  backFunc?: () => void;
  isGhost?: boolean;
}

const PageNavbar = (props: IProps) => {
  const [statusHeight, setStatusHeight] = useState(50);
  const {
    className,
    title = '',
    rightContent = '',
    isBlack = false,
    backFunc = () => {},
    isGhost = false,
    ...extraProps
  } = props;

  useEffect(() => {
    if (env.isHelloPetApp) {
      nativeBridge?.toggleNavbar(false);
      nativeBridge?.getStatusBarAndNavBarHeight().then((res: any) => {
        console.log(res);
        setStatusHeight((res.statusBarHeight as number) || 50);
      }).catch((error) => console.log(error));
      return () => {
        nativeBridge?.toggleNavbar(true);
      };
    }
  }, []);
  
  return (
    <div style={{ height: isGhost ? 0 : statusHeight + 25 }}>
      <div className={`page-navbar ${className}`} {...extraProps}>
        <div
          // onClick={() => {
          //   if (process.env.NODE_ENV === 'development') {
          //     Native.reload();
          //   }
          // }}
          style={{ height: statusHeight }}
        ></div>
        <div className="page-navbar-top">
          <div className="page-navbar-top-back">
            <img
              className="page-navbar-top-back-icon"
              onClick={() => {
                backFunc?.();
                Native.closeWebView();
              }}
              src={
                isBlack
                  ? 'https://m.hellobike.com/resource/gallery/64/wU6BNNa8_taichi_image.png'
                  : 'https://m.hellobike.com/resource/gallery/64/PV0wWG_X_taichi_image.png'
              }
            />
            <span
              className="page-navbar-top-back-title"
              style={{ color: isBlack ? '#fff' : '#000' }}
            >
              {title}
            </span>
          </div>
          <div className="page-navbar-top-right">{rightContent}</div>
        </div>
      </div>
    </div>
  );
};

export default PageNavbar;
